/*
Copyright 2023 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

export let StatsReport = /*#__PURE__*/function (StatsReport) {
  StatsReport["CONNECTION_STATS"] = "StatsReport.connection_stats";
  StatsReport["CALL_FEED_REPORT"] = "StatsReport.call_feed_report";
  StatsReport["BYTE_SENT_STATS"] = "StatsReport.byte_sent_stats";
  StatsReport["SUMMARY_STATS"] = "StatsReport.summary_stats";
  return StatsReport;
}({});

/// ByteSentStatsReport ################################################################################################

/// ConnectionStatsReport ##############################################################################################

/// SummaryStatsReport #################################################################################################

/// CallFeedReport #####################################################################################################
//# sourceMappingURL=statsReport.js.map